<template>
	<div class="grid ml-0 mr-0 " :class="linecolor">	



<div class="col-1"  @click="gotoPage(routename,{[route_param]:dataitem.id})">
<p class="text-primary p-link mt-4 mb-4">{{dataitem.lowerlimit}}</p>
</div>
<div class="col-1">
	<span class="material-icons-outlined md-24 mr-2 text-primary mt-4"
    >
    settings_ethernet
    </span>
</div>

<div class="col-1"  @click="gotoPage(routename,{[route_param]:dataitem.id})">
<p class="text-primary p-link mt-4 mb-4">{{dataitem.upperlimit}}</p>
</div>

<div class="col-1">
	<span class="material-icons-outlined md-24 mr-2 text-primary mt-4"
    >
    keyboard_double_arrow_right
    </span>
</div>

<div class="col-3"  @click="gotoPage(routename,{[route_param]:dataitem.id})">
<p class="text-primary p-link mt-4 mb-4">{{dataitem.customattribute.name}}</p>
</div>

<div class="col-3">
	<template v-if="dataitem.customattribute.type=='select'">
		<template v-if="dataitem.attributeoption.color">
		<p class=" p-link mt-4 mb-4" :style="'color:#'+dataitem.attributeoption.color"><b>{{dataitem.attributeoption.name}}</b></p>
			
		</template>
		<template v-else>
		<p class="text-primary p-link mt-4 mb-4">{{dataitem.attributeoption.name}}</p>
			
		</template>
	</template>
	<template v-if="dataitem.customattribute.type=='string'">
		<p class="text-primary p-link mt-4 mb-4">{{dataitem.customattribute_text_val}}</p>
	</template>
	<template v-if="dataitem.customattribute.type=='number'">
		<p class="text-primary p-link mt-4 mb-4">{{dataitem.customattribute_numeric_val}}</p>
	</template>
	<template v-if="dataitem.customattribute.type=='boolean'">
		<template v-if="dataitem.customattribute_numeric_val===0" >
			<i class="pi pi-exclamation-circle mr-3 text-red-500 text-2xl font-bold mt-4" ></i>
		</template>
		<template v-if="dataitem.customattribute_numeric_val===1" >
			<i class="pi pi-check-circle mr-3 text-primary text-2xl font-bold mt-4" ></i>
		</template>
	</template>

</div>








<div class="col-2">
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,dataitem.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+dataitem.id" class="p-button-primary p-button-text p-button-sm mt-3"   />
<Menu :id="'overlay_menu'+dataitem.id" :ref="'menu'+dataitem.id" :model="items" :popup="true">
 <template #item="{item}">  
  <template v-if="item.label=='Sil'">
    
      <a class="p-menuitem-link" 
      role="menuitem" 
      @click="item.command(item.deleteobjectname)"
      >
      <span :class="'p-menuitem-icon '+item.icon"></span>
      <span class="p-menuitem-text">{{item.label}}</span>
      <span class="p-ink"></span></a>
  </template>
  <template v-else>
    <a class="p-menuitem-link" 
      role="menuitem" 
      @click="item.command(item.routename,{[route_param]:dataitem.id})"
      >
      <span :class="'p-menuitem-icon '+item.icon"></span>
      <span class="p-menuitem-text">{{item.label}}</span>
      <span class="p-ink"></span></a>
  </template>

</template>
</Menu>
</div>
</div>
</template>

<script>
export default {
props:["dataitem","index","name_parameter","routename","route_param","deleteobjectname","show_index"],
  name: 'QuestionlistCalculationLine',

   computed:{
  	linecolor()
  	{
  		if( (this.dataitem.queue+2) % 2 == 0)
  		{
  			return "even theline"
  		}
  		else
  		{
  			return "odd theline"
  		}
  	},
    theindex()
    {
      if(this.show_index)
      {
        return this.dataitem.queue+1
      }
      else
      {
        return ""
      }
    }
  },
  data () {
    return {
    	items: [
    		{
                label: 'Görüntüle',
                icon: 'pi pi-eye',
                routename:this.routename,
                route_param:this.route_param,
                command: (routename,route_param) => {
                  //return false
                  console.log(routename)
                  console.log(route_param)
                  //return  false
	                   //this.gotoPage(routename,route_param)
                     //this.$router.push({ name: "Educationpackvideo" })  
                     this.$router.push({ name: routename,params:route_param })
	                }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                deleteobjectname:this.deleteobjectname,
                command: (deleteobjectname) => {
                  //return false
	                   this.deleteItem(deleteobjectname,this.dataitem.id)
	                }
            },

    	]
    }
  },
  methods:{
  	toggle(event,id) {      
      //return false
        this.$refs['menu'+id].toggle(event);
    },
  }
}
</script>

<style lang="css" scoped>
.theline{
	border-top: 1px solid rgb(233, 236, 239);
}
.even{
	background-color: rgba(252,252,252,1);
}
</style>